<template>
    <div>
        <form
            :action="RoutePathCustomerEnum.Auth_Logout"
            method="POST"
            ref="logoutForm"
        ></form>
        <BaseCustomerProfileDropdown
            :callback="() => logoutForm?.submit()"
            :customer="customer"
        />
    </div>
</template>

<script setup lang="ts">
    import { ref } from 'vue'
    import BaseCustomerProfileDropdown from '@/Shared/Layout/Customer/BaseCustomerProfileDropdown.vue'
    import Customer from '@/App/Customer/Entity/Customer'
    import { RoutePathCustomerEnum } from '@/Shared/AutoGenerated/RoutePathEnum'

    interface ProfileDropdownProps {
        customer: Customer
    }

    const props = defineProps<ProfileDropdownProps>()
    const logoutForm = ref()
</script>
